/**
 * 生成が編集用 pptx のスライド外へ置く「AI の要確認事項」のテキストボックスの目印。
 *
 * ボックスは生成のたびにサーバーが捨てて作り直す図形で、プロンプトの書き込み先にはならない。
 * 一覧や候補に出ると、利用者が選んだ担当が次の生成で書き込み先を失って未記入になるので、
 * 走査の入口で外す（`reconcileUids.ts`）。
 *
 * **この名前はサーバーにも定数がある**（`packages/lambda/layer/infrastructure/pptx/review_notes.py` の
 * `REVIEW_SHAPE_NAME`）。パッケージをまたぐ共有の仕組みが無いので、識別子のタグ名と同じく両側に
 * 持つ。片方だけ変えると、取り除かれない・外されない図形が生まれる。
 *
 * 設計: docs/notes/設計ノート/2026-10-02設計ノート要確認事項を編集用pptxのスライド外に書く.md ⑦
 */
export const REVIEW_NOTE_SHAPE_NAME = "im.review";

/** 図形が要確認事項のボックスか。 */
export function isReviewNoteShape(shape: { name: string }): boolean {
    return shape.name === REVIEW_NOTE_SHAPE_NAME;
}
